function SubscriptionPageFailure() {
  return <div>Zakup nie powiódł się! Spróbuj jeszcze raz</div>;
}

export default SubscriptionPageFailure;
